import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import logoImg from "../../assets/icons/logo-lisa.svg";
import { RootState } from "../../store";
import {
  CloseAiButton,
  Container,
  LisaLogo
} from "./styles";
import iconAccessibility from "../../assets/icons/accessibility.svg";
import iconTutorial from "../../assets/icons/tutorial.svg";
import iconTime from "../../assets/icons/nosso-time.svg";
import { useNavigate } from "react-router-dom";
import iconBackArrow from "../../assets/icons/back-arrow-filled.svg";
import iconImport from "../../assets/icons/send.svg";
import iconEval from "../../assets/icons/eval.svg";
import iconLogin from "../../assets/icons/login-icon.svg";
import iconHamburguer from "../../assets/icons/menu-hamburguer.svg";
import closeIcon from "../../assets/icons/close-icon.svg";

interface HeaderProps {
  scenarioName?: string;
  onBack?: () => void;
  backToHome?: () => void;
  onImportClick: () => void;
  onEvalClick: () => void;
  headerPage?: number;
  toggleSidebar: () => void;
  showSidebar: boolean;
  isAccessibilityOpen: boolean;
  setIsAccessibilityOpen: (isOpen: boolean) => void;
  Aimode: boolean; 
  closeAimode : (bool: boolean) => void;
}

export function Header({ 
  scenarioName, 
  onBack,
  backToHome,
  onImportClick,
  onEvalClick,
  toggleSidebar,
  showSidebar,
  headerPage = 0,
  Aimode,
  closeAimode,
  isAccessibilityOpen,
  setIsAccessibilityOpen
  
}: HeaderProps) {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const font = useSelector<RootState>((state) => state.font.fontSize);
  window.localStorage.setItem("globalFontSize", `${font}`);
  const globalFontSize = localStorage.getItem("globalFontSize");
  const navigate = useNavigate();
  const menuRef = useRef<HTMLDivElement>(null);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);


  document.body.style.fontSize = `${globalFontSize}px`;
  

  useEffect (()=>{
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 769)
    }
    checkScreen();
    window.addEventListener('resize', checkScreen)
    return () => window.removeEventListener('resize', checkScreen)
  }, [])

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleMenuNavigate = (path: string) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const closeAi = () => {
    if (window.location.pathname === "/home") {
      closeAimode(false);
    }
    backToHome?.();
  };

  const openMenu = () => {
    setIsMenuOpen((prev) => !prev);
  }

  const handleImportClick = () => {
    onImportClick();
  };

  const handleEvalClick = () => {
    onEvalClick();
  };

  const getDynamicFontSize = (text:string) => {
    const length = text.length;

    if (length < 10) return "1.8rem";
    if (length < 15) return "1.4rem";
    if (length < 20) return "1.1rem";
    return "1.1rem";
  }
  return (
    <Container>
      {(Aimode && headerPage == 0) ? (
      <div
        className="menuButtom hint"
        data-tutorial="menu-hamburguer"
        data-hint="Menu"
        data-hint-placement="bottom-left"
        onClick={toggleSidebar}
        tabIndex={1}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggleSidebar();
          }
        }}
      >
        <img className="iconHamburguer" src={iconHamburguer} alt="Menu" />
      </div>
      ) : <div/>}

      { isMobile && (scenarioName) ? (
        <div className="header">
          {headerPage == 0 && (
            <>
              {onBack && (
                <div className="backIcon icon"
                onClick={onBack}
                >
                  <img
                    src={iconBackArrow}
                    alt="Voltar"
                  />
                </div>
              )}
              <div className="title">
                 <span style={{ fontSize: getDynamicFontSize(scenarioName) }}>
                    {scenarioName}
                  </span>
              </div>
              <div className="auxiliarIcons icon">
                <div className="evalIcon hint" data-hint="Avaliar" data-hint-placement="bottom-left" onClick={handleEvalClick} >
                  <img src={iconEval} alt="Feedback"/>
                </div>
                <div className="exportIcon hint" data-hint="Receber Email" data-hint-placement="bottom-left" onClick={handleImportClick} >
                  <img src={iconImport} alt="Exportar"/>
                </div>
              </div>
            </>
          )}

          {headerPage > 0 && (
            <>
            {showSidebar ? (
              <div className="menuButtom hint" data-hint="Menu" data-hint-placement="top-left" onClick={toggleSidebar}>
                <img
                  src={closeIcon}
                  alt="menu" 
                />
              </div>
            ) : (
              <img
                onClick={toggleSidebar}
                src={iconHamburguer}
                alt="menu hamburguer"
              />
            )}
              
              {onBack && (
                <div className="backIcon icon"
                onClick={onBack}
                >
                  <img
                    src={iconBackArrow}
                    alt="Voltar"
                  />
                </div>
              )}

              {headerPage == 1 &&
                <div className="title">
                  <span>{scenarioName} / <u>Enviar por e-mail</u></span>
                </div>
              }
              {headerPage == 2 &&
                <div className="title">
                  <span>{scenarioName} / <u>Avaliação</u></span>
                </div>
              }
            </>
          )}
        </div>
      ) : (
        
        
        
      
        <LisaLogo className="hint" data-hint="Home" data-hint-placement="bottom" onClick={closeAi} tabIndex={1} onKeyDown={(e) => {if ((e.key === 'Enter' || e.key === ' ') && backToHome) {e.preventDefault(); closeAi();}}} >
            <img src={logoImg} alt="Lisa" />
            <span id="Lisa">Lisa</span>

        </LisaLogo>

        
      )}
      {/* <div className="accessibilityButton hint"
        data-hint="Acessibilidade"
        data-hint-placement="bottom-right"
        onClick={() => setIsAccessibilityOpen(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsAccessibilityOpen(true)
          }
        }}
        tabIndex={2}
        >
        <img
          className="accessibility"
          src={iconAccessibility}
          alt="Acessibilidade"
        />
      </div> */}
      {
        !Aimode ?
        <div
          className="menuHamburguerWrapper hint"
          data-hint="Menu"
          data-hint-placement="bottom-left"
          tabIndex={1}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openMenu();
            }
          }}
        >
          <img
            onClick={openMenu}
            className="menuHamburguer"
            src={iconHamburguer}
            alt="menu hamburguer"
          />

          {isMenuOpen && (
            <div ref={menuRef} className="menu" onClick={(e) => e.stopPropagation()}>
              <button
                className="menu-close"
                aria-label="Fechar menu"
                onClick={() => setIsMenuOpen(false)}
              >
                ×
              </button>
              <div onClick={() => handleMenuNavigate("/time")} className="menu-item">
                <img src={iconTime} alt="Nosso Time Icon" />
                Quem Contribuiu
              </div>
              <div onClick={() => handleMenuNavigate("/tutorial")} className="menu-item">
                <img src={iconTutorial} alt="Tutorial Icon" />
                Tutorial
              </div>
              <div onClick={() => handleMenuNavigate("/login")} className="menu-item">
                <img src={iconLogin} alt="Área Restrita Icon" />
                Área Restrita
              </div>
              {/* <div onClick={handleTutorial} className="menu-item">
              <img src={iconTutorial} alt="Tutorial Icon" />
              Tutorial
            </div> */}
            </div>
          )}
        </div>
        : <CloseAiButton onClick={() => closeAimode(false)}>Sair</CloseAiButton>
      }
    </Container>
  );
}
